module.exports = __webpack_public_path__ + "img/photo-05.05766ef5.jpg";